export const CompareOperator = {
  gt: 'greater-than',
  gte: 'greater-than-or-equal-to',
  lt: 'lower-than',
  lte: 'lower-than-or-equal-to',
  eq: 'equals',
  neq: 'not-equal-to',
}

export class Comparison
{
  rules = {
    default: { operator: CompareOperator.gt },
    age: { operator: CompareOperator.gt },
    fact: { operator: CompareOperator.gt },
    rank: { operator: CompareOperator.lt },
  };

  setRules = (obj) => {
    this.rules = {...this.rules, ...obj};
  };

  firstValueWins = (value1, value2, type) => {
    let result;
    const rule = this.rules[type] || this.rules.default;
    if (value1 !== value2 && !isNaN(value1) && !isNaN(value2)) {
      switch (rule.operator) {
        case CompareOperator.gt:
          result = value1 > value2;
          break;
        case CompareOperator.gte:
          result = value1 >= value2;
          break;
        case CompareOperator.lt:
          result = value1 < value2;
          break;
        case CompareOperator.lte:
          result = value1 <= value2;
          break;
        case CompareOperator.neq:
          result = value1 !== value2;
          break;
        default:
          result = undefined;
      }
    }
    return result;
  }
}
